import * as impact from './impact';

const pollImpact = (setImpact, merchantCode) =>{
  loadImpact(merchantCode, setImpact);

    var intervalId = window.setInterval(function(){
        loadImpact(merchantCode, setImpact);
    }, 5000);
};

export {pollImpact};

function loadImpact(merchantCode, setImpact) {
  impact.merchants(merchantCode, null) // fetch updated impact
    .then(response => response.json())
    .then(body => {
      setImpact(body);
    })
    .catch(error => {
      setImpact(error);
    })
    .finally();
}
